/* global axios */
// Cấu hình NHÓM (skill) agent cho queue ACD — CHÈN vào trang Settings → Agents có sẵn
// của Chatwoot (đúng ngữ cảnh: gán nhóm ngay cạnh tên agent).
//
// KHÔNG patch file .vue core: chỉ QUAN SÁT DOM Chatwoot render ở /settings/agents rồi
// chèn thêm hàng checkbox nhóm vào mỗi dòng agent (map theo email). Element tự chứa.
// Chỉ admin + chỉ chế độ acd.

// Fallback khi API chưa trả groups (image cũ). Nguồn thật: response GET
// /voice/admin/agents trường `groups` — nhóm per-account từ integration TinoFone.
const DEFAULT_SKILL_LABELS = { kd: 'Kinh doanh', hotro: 'Hỗ trợ' };
const MARK_ATTR = 'data-cw-voice-groups'; // đánh dấu dòng đã chèn (tránh chèn trùng)

let skillsCache = {}; // email → skills[] (từ API)
let skillLabels = { ...DEFAULT_SKILL_LABELS }; // key → tên hiển thị (per-account)
let started = false;

function accountId() {
  const path = window.location.pathname;
  return path.includes('/app/accounts') ? path.split('/')[3] : '';
}
function apiBase() {
  return `/api/v1/accounts/${accountId()}/voice/admin/agents`;
}
function onAgentsPage() {
  // Chatwoot route trang Agents = /settings/agents/list (cũng chấp nhận /settings/agents).
  return /\/settings\/agents(\/list)?\/?$/.test(window.location.pathname);
}

async function loadSkills() {
  try {
    const { data } = await axios.get(apiBase());
    skillsCache = {};
    (data.agents || []).forEach(a => {
      skillsCache[(a.email || '').toLowerCase()] = { skills: a.skills || [], userId: a.user_id };
    });
    if (Array.isArray(data.groups) && data.groups.length) {
      skillLabels = {};
      data.groups.forEach(g => {
        if (g.key) skillLabels[g.key] = g.name || g.key;
      });
    }
  } catch (e) {
    skillsCache = {};
  }
}

async function saveSkills(userId, skills) {
  await axios.put(`${apiBase()}/${userId}`, { skills });
}

// Tạo hàng checkbox nhóm cho 1 agent (email đã biết).
function buildGroupRow(email) {
  const rec = skillsCache[email.toLowerCase()];
  const wrap = document.createElement('div');
  wrap.style.cssText =
    'display:flex;align-items:center;gap:14px;margin-top:6px;padding:6px 10px;' +
    'border-radius:8px;background:rgba(99,102,241,.06);font:12px system-ui,sans-serif;';

  const tag = document.createElement('span');
  tag.textContent = 'Nhóm tổng đài:';
  tag.style.cssText = 'color:rgb(var(--slate-11,120 124 132));font-weight:600;';
  wrap.appendChild(tag);

  if (!rec) {
    const na = document.createElement('span');
    na.textContent = '(chưa có dữ liệu)';
    na.style.color = 'rgb(var(--slate-10,150 150 150))';
    wrap.appendChild(na);
    return wrap;
  }

  const status = document.createElement('span');
  status.style.cssText = 'font-size:11px;margin-left:6px;';
  const boxes = {};
  Object.keys(skillLabels).forEach(sk => {
    const lbl = document.createElement('label');
    lbl.style.cssText = 'display:flex;align-items:center;gap:4px;cursor:pointer;';
    const cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.checked = rec.skills.includes(sk);
    boxes[sk] = cb;
    const s = document.createElement('span');
    s.textContent = skillLabels[sk];
    lbl.append(cb, s);
    wrap.appendChild(lbl);
  });

  const save = async () => {
    const skills = Object.keys(boxes).filter(sk => boxes[sk].checked);
    status.textContent = 'đang lưu...';
    status.style.color = '#2781F6';
    try {
      await saveSkills(rec.userId, skills);
      rec.skills = skills;
      status.textContent = '✓';
      status.style.color = 'rgb(var(--teal-11,0 133 115))';
    } catch (e) {
      status.textContent = 'lỗi';
      status.style.color = 'rgb(var(--ruby-11,202 36 77))';
    }
    setTimeout(() => (status.textContent = ''), 2000);
  };
  Object.values(boxes).forEach(cb => cb.addEventListener('change', save));
  wrap.appendChild(status);
  const hint = document.createElement('span');
  hint.textContent = '(không tích = nhận mọi nhóm)';
  hint.style.cssText = 'color:rgb(var(--slate-10,150 150 150));font-size:11px;';
  wrap.appendChild(hint);
  return wrap;
}

// Quét DOM trang Agents, chèn hàng nhóm vào mỗi dòng agent chưa được chèn.
// Nhận diện dòng agent qua email (Chatwoot render email dạng text trong dòng).
function injectIntoAgentRows() {
  if (!onAgentsPage()) return;
  // Mỗi dòng agent (Chatwoot) là div "...py-4" chứa <span> email. Tìm span leaf chứa
  // email, LẤY DÒNG qua closest py-4 (chỉ dòng agent có class này — loại email ở
  // sidebar profile không có py-4).
  const emailEls = [...document.querySelectorAll('span.text-body-main, span')].filter(el => {
    if (el.children.length > 0) return false;
    const t = (el.textContent || '').trim();
    return /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(t);
  });
  emailEls.forEach(emailEl => {
    const row = emailEl.closest('[class*="py-4"]');
    if (!row || row.getAttribute(MARK_ATTR)) return;
    row.setAttribute(MARK_ATTR, '1');
    row.appendChild(buildGroupRow(emailEl.textContent.trim()));
  });
}

// Watch DOM đổi (Chatwoot render bất đồng bộ + đổi route) → chèn lại.
function startObserver() {
  const run = () => {
    if (onAgentsPage()) injectIntoAgentRows();
  };
  const mo = new MutationObserver(() => run());
  mo.observe(document.body, { childList: true, subtree: true });
  // Poll nhẹ mỗi 2s cho chắc (route SPA đổi không phải lúc nào cũng trigger MO).
  setInterval(run, 2000);
  run();
}

function isAdmin(store) {
  try {
    const u = store?.getters?.getCurrentUser;
    const role = u?.role || u?.accounts?.find(a => `${a.id}` === accountId())?.role;
    return role === 'administrator';
  } catch (e) {
    return false;
  }
}

// Entry: admin + acd mode → load skills + observe trang Agents.
export async function startVoiceAdminGroups(store) {
  if (started || !isAdmin(store)) return;
  started = true;
  await loadSkills();
  startObserver();
}

export default startVoiceAdminGroups;
